import * as React from 'react';
import {IDocFieldProps} from 'myshubhlife-component/form/FormInterfaceProps';
import DocInput from 'myshubhlife-component/docInput';
import {DocTypes} from 'myshubhlife-component/docInput';

function DocUpload (props: IDocFieldProps) {
  const handleFileInput = (b64, type: DocTypes) => {
    props.handleFormChange(b64, props.index, 'value');
    props.handleFormChange(type, props.index, 'type');
  }
  return (
    <div className="s-form-group-field">
      <DocInput 
      type={props.field.type}
      primaryLabel={props.field.label}
      handleFileInput={handleFileInput}
      secondaryLabel={props.field.secondaryLabel}
      errorMsg={props.field.errorMsg}
      backgroundColor={props.field.docBgColor}
      />
    </div>
  )
}

export default DocUpload;